import React, { useState, useEffect } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

function Date({ onDateChange, existingDate, className, type }) {
  const [value, setValue] = useState();

  useEffect(() => {
    if (existingDate) {
      // Convert existingDate to a Day.js object
      setValue(dayjs(existingDate));
    }
  }, [existingDate]);

  const handleDate = (newValue) => {
    setValue(newValue);
    if (newValue) {
      const year = newValue.year(); // Get year
      const month = newValue.month() + 1; // Get month (1-based)
      const day = newValue.date(); // Get day of the month

      // Pass the extracted date components to the parent callback
      onDateChange(year, month, day, type);
    }
    // onDateChange(value);
  };
  return (
    <div className={`w-full ${className}  py-0 bg-white rounded-md`}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        // sx={{ margin: 0, padding: 0 }}
      >
        <DemoContainer
          components={["DatePicker"]}
          sx={{ margin: 0, padding: 0, overflow: "visible" }}
        >
          <DatePicker
            sx={{
              width: "100%",
              padding: 0,
              margin: 0,
              "& .MuiInputBase-root": {
                height: "42px",
              },
              "& .MuiInputBase-input": {
                padding: "8px 14px",
              },
            }}
            value={value}
            onChange={handleDate}
          />
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
}
export default Date;
